import React from 'react'
import { CompactPicker, SketchPicker } from 'react-color'
import { preventBubbling } from '@pushly/aqe/lib/utils/prevent'
import { getClassNames } from '../../_utils/classnames'
import { Flex, Popover, Space, Switch } from 'antd'

import './color-picker-popover.scss'

type Color = string | null | undefined

interface IColorPickerPopoverProps {
    className?: string
    defaultColor?: Color
    color: Color
    onChange: (color: Color) => void
    content?: React.ReactNode
    disabled?: boolean
    picker?: 'sketch' | 'compact'
}

const ColorPickerPopover = (props: IColorPickerPopoverProps) => {
    // @ts-ignore
    const popoverRef = React.createRef<Popover>()
    let { picker } = props

    picker ??= 'compact'

    return (
        <Popover
            ref={popoverRef}
            classNames={{
                root: getClassNames(null, props.className, 'color-picker-popover-trigger'),
                content: getClassNames(null, 'color-picker-popover', {
                    disabled: props.disabled,
                }),
            }}
            styles={{ container: { padding: 0 } }}
            trigger="click"
            content={
                picker === 'sketch' ? (
                    <SketchPicker
                        disableAlpha={true}
                        presetColors={[]}
                        color={props.color ?? '#FFF'}
                        onChangeComplete={(res) => {
                            const hex = res.hex?.trim()
                            props.onChange(!!hex ? hex : null)
                        }}
                    />
                ) : (
                    <CompactPicker
                        color={props.color ?? '#FFF'}
                        onChangeComplete={(res) => {
                            const hex = res.hex?.trim()
                            props.onChange(!!hex ? hex : null)
                        }}
                    />
                )
            }
        >
            {props.content ? (
                props.content
            ) : (
                <Flex vertical gap={4} className="color-picker-popover-preview">
                    <div
                        className="color-preview-swatch"
                        style={{
                            backgroundColor: !props.color ? '#FFF' : props.color,
                        }}
                    />
                    <Flex
                        justify="space-between"
                        className="meta"
                        onClick={(ev) => {
                            const isVisible = (popoverRef.current as any)?.tooltip?.state?.visible ?? false

                            if (!isVisible && !(ev.target as HTMLElement).classList.contains('ant-switch')) {
                                preventBubbling(ev)
                            }
                        }}
                    >
                        <span className="toggle">
                            <Switch
                                size="small"
                                checked={!!props.color}
                                onChange={(checked) => {
                                    props.onChange(checked ? props.defaultColor ?? '#FFF' : null)
                                }}
                                onClick={(checked, ev) => {
                                    const isVisible = (popoverRef.current as any)?.tooltip?.state?.visible ?? false

                                    if ((!checked && !isVisible) || (checked && isVisible)) {
                                        preventBubbling(ev)
                                    }
                                }}
                                aria-label="Enable color selection"
                            />
                        </span>
                        <span className="color-code">{props.color ?? 'N/A'}</span>
                    </Flex>
                </Flex>
            )}
        </Popover>
    )
}

export default ColorPickerPopover
